import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box, useMediaQuery, useTheme } from "@mui/material";

interface ITeamsInfoSetupFieldsPanel {
	onTeamsSelectionChangeHandler: (value: any) => void;
	teamsDDLItems: any

}
export const TeamsInfoSetupFieldsPanel: FC<
	ITeamsInfoSetupFieldsPanel
> = ({ teamsDDLItems, onTeamsSelectionChangeHandler }) => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
	return (
		<Box>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Teams"
				selectName="teams"
				testId={`teams`}
				labelPosition={LabelPosition.Top}
				items={teamsDDLItems ?? []}
				onSelectionChangeHandler={onTeamsSelectionChangeHandler}
				showEmpty
			/>}
			<RHookFormTextFieldWithLabel
				label="Code"
				id="code"
				testId={`code`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Label"
				id="teamLabel"
				testId={`Team-Label`}
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			// required
			/>
			<EnhancedTextAreaFieldRHF
				label="Notes"
				id="notes"
				testId={`notes`}
				// placeholder="Notes"
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			/>
		</Box>
	);
};
